import React from 'react'
import InfoContent from 'components/InfoContent'
import { useHistory } from "react-router"
import routesConfig from "routesConfig"
import finisridecancelimg from './img/ridecancel.png'

export default function RideGuide(props) {
    const history = useHistory()

    const contents = [
        {
            title: "سفر درخواستی لغو شد",
            description: "لغو سفر معمولا به دلیل خطا در ارتباط با وسیله ی نقلیه در دقیقه ی ابتدایی سفر اتفاق می افتد." +
            "لطفا مجددا درخواست ثبت نمایید ",
            img: finisridecancelimg
        }
    ]
    const onFinish = () => {
        history.push(routesConfig.home)
    }

    return <InfoContent contents={contents} autoplay={false} onFinish={onFinish} />

}